import React, {Component} from 'react';
import {connect} from 'react-redux';
import TeamOptions from 'components/organisms/team-name-stacking/components/team-options';
import Const from 'constants';
import {generateRandomKey} from 'helpers/hash';

class TeamOptionsList extends Component {
    getMaxPlayers() {
        const {sportConfig} = this.props;

        return sportConfig.getConfigProp('maxSingleTeamPlayers', Const.MIN_PLAYERS_IN_TEAM_STACK);
    }

    getTeamOptions(teamName) {
        const {stacking} = this.props;

        return (
            stacking.getItem(teamName) ?? {
                enabled: stacking.getDefaultTeamOptionsEnabledStatus(),
                minPlayers: 0,
                maxPlayers: this.getMaxPlayers(),
            }
        );
    }

    render() {
        const {activeTeamNames, teamsInfo} = this.props;

        return (
            <div className="team-limits-container">
                {activeTeamNames.map((teamName) => (
                    <TeamOptions
                        teamInfo={teamsInfo.getById(teamName)}
                        teamName={teamName}
                        maxSingleTeamPlayers={this.getMaxPlayers()}
                        teamOptions={this.getTeamOptions(teamName)}
                        key={`${teamName}-${generateRandomKey()}`}
                    />
                ))}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    return {
        activeTeamNames: state.playersData.filters.games,
        stacking: state.teamNameStacking,
        sportConfig: state.sportConfig,
        teamsInfo: state.teamsInfo,
    };
}

export default connect(mapStatesToProps)(TeamOptionsList);
